import { render, staticRenderFns } from "./IconCard.vue?vue&type=template&id=cd20d93a&"
import script from "./IconCard.vue?vue&type=script&lang=js&"
export * from "./IconCard.vue?vue&type=script&lang=js&"
import style0 from "./IconCard.vue?vue&type=style&index=0&id=cd20d93a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports